import React from 'react';
import './ProfileDetailsContainer.css';

function ProfileDetailsContainer({ children }) {
  return (
    <div className="profile-details-container mb-[60px] px-5 py-[40px] md:px-[30px]">
      {children}
    </div>
  );
}

export default ProfileDetailsContainer;
